export default {
  namespaced: true,
  state: {
    min_viewing_time: {
      selected: 15, //Value must exist in options
      options: [        
        { value: 1, text: "1 sek", selectedReachCriteriaText: '1 sek' },
        { value: 2, text: "2 sek", selectedReachCriteriaText: '2 sek' },
        { value: 5, text: "5 sek", selectedReachCriteriaText: '5 sek' },
        { value: 10, text: "10 sek", selectedReachCriteriaText: '10 sek' },
        { value: 15, text: "15 sek el 50% av längd", selectedReachCriteriaText: '15 sek/50%' },
        { value: 20, text: "20 sek", selectedReachCriteriaText: '20 sek' },
        { value: 30, text: "30 sek", selectedReachCriteriaText: '30 sek' },
        { value: 60, text: "60 sek", selectedReachCriteriaText: '60 sek' },
        { value: 120, text: "120 sek", selectedReachCriteriaText: '120 sek' },
        { value: 180, text: "180 sek", selectedReachCriteriaText: '180 sek' }
      ]
    },
    measure_type: {
      selected: "absolute_reach", //Value must exist in options
      options: [
        { value: "absolute_reach", text: "Absolut" },
        { value: "relative_reach", text: "Relativ" }
      ]
    }
  },
  getters: {
    getSelectedReachObj: state => state.min_viewing_time,
  },
  mutations: {
    updateMinViewingTimeSite(state, newSelection) {
      state.min_viewing_time.selected = newSelection;
    },
    updateMeasureTypeSite(state, newSelection) {
      state.measure_type.selected = newSelection;
    }
  }
};
